import React, { useState, useEffect, useContext, useCallback } from "react";
import env from "../../config/environment";
import AppContext from "../../contexts/appContext";
import AjaxSpinner from "../../components/AjaxSpinner/AjaxSpinner";
import api from "../../utils/api";
import masks from "../../utils/masks";
import dateUtils from "../../utils/date";
import ibcParser from "../../utils/ibcParser";
import * as lgpdApi from "../../utils/lgpd-api";
import { isEmpty } from "../../utils/checkIf";

const IBCInterceptor = (props) => {
  const context = useContext(AppContext);
  const [loading, setLoading] = useState(true);

  const showError = () => {
    context.setContext({
      ...context,
      error: {
        show: false,
        internalError: () => {
          return "Não foi possível obter os dados da integração :(";
        },
      },
    });
    setLoading(false);
  }

  const go2Products = (setContext = true) => {
    if (setContext) {
      context.setContext({
        ...context,
        ibc: false,
      });
    }

    setTimeout(() => {
      props.history.replace({
        pathname: "/produtos",
      });
    }, 0);
  };

  const fetchLgpdConsent = useCallback(async () => {
    if (context.ibc && context.ibcUser) {
      const cpf = masks.numberOnly(context.ibcUser.cpf);
      const promises = [
        lgpdApi.getLgpdConsent(
          env.BUSINESS_PROCESS_CODE,
          env.BUSINESS_SUBPROCESS_CAIXA_HOLDING_CODE,
          cpf
        ),
        lgpdApi.getLgpdConsent(
          env.BUSINESS_PROCESS_CODE,
          env.BUSINESS_SUBPROCESS_CAIXA_HOLDING_PARTNERS_CODE,
          cpf
        ),
      ];
      Promise.all(promises)
        .then((res) => {
          if (res.every((el) => isEmpty(el) === false && el.status === 200)) {
            res.map((el) =>
              context.setContext({
                ...context,
                lgpdConsent: `${el.data[0] ? el.data[0].consentimento.tipo : ''}`,
              })
            );
          }
        })
        .catch(() => {
          showError();
        });
    }
  }, [context.ibc, context.ibcUser]);

  const updateUser = useCallback((token) => {
    if (token.length > 0) {
      api
        .get(api.endpoints.USER_XML, { token })
        .then((result) => {
          const { dados, end, ccs } = result.data.cliente;
          context.setContext({
            ...context,
            ibc: true,
            ibcUser: {
              nome: dados.pf.nome,
              cpf: masks.cpf(dados.cpf_cnpj),
              documento: dados.pf.rg,
              emissor: dados.pf.org_emis,
              emissorUF: dados.pf.uf_org_emis,
              emissorCode: dados.pf.org_emis_sigla,
              nascimento: dateUtils.format(
                new Date(
                  `${dados.pf.dt_nasc.slice(0, 4)}-${dados.pf.dt_nasc.slice(
                    4,
                    6
                  )}-${dados.pf.dt_nasc.slice(6, 8)}T00:00:00`
                )
              ),
              estadocivil: ibcParser.parseCivilState(dados.pf.est_civ).code,
              estadocivilName: ibcParser.parseCivilState(dados.pf.est_civ).name,
              nacionalidade: "",
              estado: "",
              naturalidade: "",
              acessibilidade: "",
              sexo: dados.pf.sexo,
              profissao: "",
              profissaoName: dados.pf.no_prof,
              mae: dados.pf.mae,
              celular: `${dados.pf.ddd_celular}${dados.pf.tel_celular}`,
              fixo:
                `${dados.pf.ddd_res}${dados.pf.tel_res}` ||
                `${dados.pf.ddd_com}${dados.pf.tel_com}`,
              email: dados.pf.email,
              endereco: {
                cep: end.gen.cep,
                street: end.gen.logr,
                number: "",
                complement: end.gen.comp,
                district: end.gen.bair,
                city: end.gen.cid,
                uf: end.gen.uf,
              },
              type: dados.tp_pes,
              accounts: ccs.cc === "" || ccs.cc == null ? [] : ccs.cc,
            },
          });

          go2Products(false);
        })
        .catch(() => {
          showError();
        });
    }
  }, []);

  useEffect(() => {
    const token = document.getElementById("lblToken").textContent;
    if (token) {
      updateUser(token);
    } else {
      go2Products();
    }
  }, [context.token, updateUser]);

  useEffect(() => {
    fetchLgpdConsent();
  }, [context.token, context.ibc, context.ibcUser]);

  return loading && <AjaxSpinner loading />;
};

export default IBCInterceptor;
